<div class="row">
  <div class="col-12 col-xxl-6">
    <input
      fullWidth
      [ngModel]="emailQuery"
      (ngModelChange)="filter($event, 'email')"
      nbInput
      dir="ltr"
      type="text"
      placeholder="جستجو کاربران بر اساس ایمیل"
      [nbAutocomplete]="email"
    />

    <nb-autocomplete #email [handleDisplayFn]="viewHandleEmail.bind(this)">
      <nb-option *ngFor="let user of filterUsersByEmail$ | async" [value]="user">
        {{ user.email }}
      </nb-option>
    </nb-autocomplete>
  </div>
  <div class="col-12 col-xxl-6">
    <input
      fullWidth
      [ngModel]="phoneQuery"
      (ngModelChange)="filter($event, 'phone')"
      nbInput
      dir="ltr"
      type="text"
      placeholder="جستجو کاربران بر اساس شماره تلفن"
      [nbAutocomplete]="phone"
    />

    <nb-autocomplete #phone [handleDisplayFn]="viewHandlePhone.bind(this)">
      <nb-option *ngFor="let user of filterUsersByPhone$ | async" [value]="user">
        {{ user.phone }}
      </nb-option>
    </nb-autocomplete>
  </div>
  <div class="col-12 mt-2 col-xxl-6">
    <input
      fullWidth
      [ngModel]="userIdQuery"
      (ngModelChange)="filter($event, 'userID')"
      nbInput
      type="text"
      placeholder="جستجو کاربران بر اساس شناسه کاربری"
      [nbAutocomplete]="nationalID"
    />

    <nb-autocomplete #nationalID [handleDisplayFn]="viewHandleUserID.bind(this)">
      <nb-option *ngFor="let user of filterUsersByID$ | async" [value]="user">
        <ng-container *ngIf="user.firstName && user.lastName; else showID">
          {{ user.firstName + ' ' + user.lastName }}
        </ng-container>
        <ng-template #showID>
          {{ user.id }}
        </ng-template>
      </nb-option>
    </nb-autocomplete>
  </div>
  <div class="col-12 mt-2 col-xxl-6">
    <input
      fullWidth
      [ngModel]="nationalIdQuery"
      (ngModelChange)="filter($event, 'nationalID')"
      nbInput
      type="text"
      placeholder="جستجو کاربران بر اساس کدملی"
      [nbAutocomplete]="nationalID"
    />

    <nb-autocomplete #nationalID [handleDisplayFn]="viewHandleNationalID.bind(this)">
      <nb-option *ngFor="let user of filterUsersByNationalID$ | async" [value]="user">
        <ng-container *ngIf="user.firstName && user.lastName; else showID">
          {{ user.firstName + ' ' + user.lastName }}
        </ng-container>
        <ng-template #showID>
          {{ user.id }}
        </ng-template>
      </nb-option>
    </nb-autocomplete>
  </div>
  <div class="col-12 mt-2 col-xxl-6">
    <input
      fullWidth
      [ngModel]="nameQuery"
      (ngModelChange)="filter($event, 'name')"
      nbInput
      type="text"
      placeholder="جستجو کاربران بر اساس نام"
      [nbAutocomplete]="name"
    />

    <nb-autocomplete #name [handleDisplayFn]="viewHandleName.bind(this)">
      <nb-option *ngFor="let user of filterUsersByName$ | async" [value]="user">
        <ng-container *ngIf="user.firstName && user.lastName; else showID">
          {{ user.firstName + ' ' + user.lastName }}
        </ng-container>
        <ng-template #showID>
          {{ user.id }}
        </ng-template>
      </nb-option>
    </nb-autocomplete>
  </div>
  <div class="col-12 mt-2 col-xxl-6">
    <input
      fullWidth
      [ngModel]="creditCardQuery"
      (ngModelChange)="filter($event, 'card')"
      dir="ltr"
      nbInput
      type="text"
      placeholder="جستجو کاربران بر اساس شماره کارت"
      [nbAutocomplete]="card"
    />

    <nb-autocomplete #card [handleDisplayFn]="viewHandleName.bind(this)">
      <nb-option *ngFor="let user of filterUsersByCreditCard$ | async" [value]="user">
        <ng-container *ngIf="user.firstName && user.lastName; else showID">
          {{ user.firstName + ' ' + user.lastName + ' (' + user.card + ')' }}
        </ng-container>
        <ng-template #showID>
          {{ user.id }}
        </ng-template>
      </nb-option>
    </nb-autocomplete>
  </div>
  <div class="col-12 mt-2 col-xxl-12">
    <input
      fullWidth
      [ngModel]="ibanQuery"
      (ngModelChange)="filter($event, 'iban')"
      nbInput
      dir="ltr"
      type="text"
      placeholder="جستجو کاربران بر اساس شماره شبا"
      [nbAutocomplete]="iban"
    />

    <nb-autocomplete #iban [handleDisplayFn]="viewHandleName.bind(this)">
      <nb-option *ngFor="let user of filterUsersByIban$ | async" [value]="user">
        <ng-container *ngIf="user.firstName && user.lastName; else showID">
          {{ user.firstName + ' ' + user.lastName + ' (' + user.iban + ')' }}
        </ng-container>
        <ng-template #showID>
          {{ user.email }}
        </ng-template>
      </nb-option>
    </nb-autocomplete>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12 h-100">
    <nb-card class="custom-card mb-0 h-100">
      <nb-card-body>
        <nb-tag-list *ngIf="selectedUsers.length > 0" (tagRemove)="onTagRemove($event)">
          <nb-tag
            *ngFor="let user of selectedUsers"
            [text]="
              user.firstName && user.lastName ? user.firstName + ' ' + user.lastName : user.email
            "
            [attr.data-delete]="user.id"
            removable
          ></nb-tag>
        </nb-tag-list>
        <div *ngIf="selectedUsers.length == 0">
          <h6 class="mb-0">هیچ کاربری انتخاب نشده است</h6>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
